export default "__VITE_PUBLIC_ASSET__4549f1d8__"